import React, {
    useEffect,
    useState
}
from "react";

import WorkspaceDrawer
from "./WorkspaceDrawer";

import {
    OMNISCAN_BLUE
}
from "../../../constants/colors";



//========================================================
// Snippet Inspect Drawer
//========================================================

export default function SnippetInspectDrawer({

    visible,

    snippet,

    onClose,

    onViewPage,

    onPreviousSnippets,

    onAddSnippet

})
{

    const [expanded, setExpanded] =
        useState(false);


    //====================================================
    // Reset Expanded State
    //====================================================

    useEffect(
        () =>
        {

            setExpanded(
                false
            );

        },
        [
            snippet?.snippetId
        ]
    );


    //====================================================
    // Content Type
    //====================================================

    const contentType =
        (
            snippet?.contentType ||
            "TEXT"
        )
            .toUpperCase();


    //====================================================
    // Structured Content
    //====================================================

    const structured =
        contentType !==
        "TEXT";


    //====================================================
    // Content Label
    //====================================================

    const contentLabel =
        getContentLabel(
            contentType
        );


    //====================================================
    // Content Description
    //====================================================

    const contentDescription =
        getContentDescription(
            contentType
        );


    //====================================================
    // Toggle Expanded
    //====================================================

    function toggleExpanded()
    {

        setExpanded(
            current =>
                !current
        );

    }


    //====================================================
    // Render
    //====================================================

    return (

        <WorkspaceDrawer
            visible={visible}
            width={540}
            right={0}
            zIndex={1000}
        >

            {/*============================================
                Header
            ============================================*/}

            <div style={styles.header}>

                <div>

                    <div style={styles.eyebrow}>

                        INSPECT SNIPPET

                    </div>

                    <div style={styles.documentTitle}>

                        {
                            snippet?.documentTitle ||
                            ""
                        }

                    </div>

                    {
                        snippet?.pageNumber != null &&
                        (

                            <div style={styles.page}>

                                Page {snippet.pageNumber}

                            </div>

                        )
                    }

                </div>


                <button
                    type="button"
                    style={styles.closeButton}
                    onClick={onClose}
                >

                    ×

                </button>

            </div>


            {/*============================================
                Content
            ============================================*/}

            <div style={styles.content}>

                <div style={styles.sectionLabel}>

                    MATCHING CONTENT

                </div>


                {/*========================================
                    Structured Content
                ========================================*/}

                {
                    structured &&
                    (

                        <div style={styles.contentPanel}>

                            <div style={styles.contentType}>

                                {contentLabel}

                            </div>

                            <div style={styles.contentDescription}>

                                {contentDescription}

                            </div>

                        </div>

                    )
                }


                {/*========================================
                    Text Content
                ========================================*/}

                {
                    !structured &&
                    (

                        <div style={styles.snippetPanel}>

                            {
                                snippet?.summary ||
                                snippet?.snippet ||
                                ""
                            }

                        </div>

                    )
                }


                {/*========================================
                    Extracted Text Action
                ========================================*/}

                {
                    snippet?.snippet &&
                    (

                        <button
                            type="button"
                            style={styles.expandButton}
                            onClick={toggleExpanded}
                        >

                            {
                                expanded
                                    ? "Hide extracted text ↑"
                                    : "Show extracted text ↓"
                            }

                        </button>

                    )
                }


                {/*========================================
                    Extracted Text
                ========================================*/}

                {
                    expanded &&
                    snippet?.snippet &&
                    (

                        <div style={styles.extractedPanel}>

                            <div style={styles.extractedLabel}>

                                EXTRACTED PAGE TEXT

                            </div>

                            <div style={styles.extractedText}>

                                {snippet.snippet}

                            </div>

                        </div>

                    )
                }


               

            </div>


            {/*============================================
                Footer
            ============================================*/}

            <div style={styles.footer}>

                <button
                    type="button"
                    style={styles.secondaryButton}
                    onClick={
                        () =>
                        {

                            if (
                                onPreviousSnippets
                            )
                            {

                                onPreviousSnippets();

                            }

                        }
                    }
                >

                    Previous Snippets

                </button>


                <button
                    type="button"
                    style={styles.primaryButton}
                    onClick={
                        () =>
                        {

                            if (
                                snippet &&
                                onAddSnippet
                            )
                            {

                                onAddSnippet(
                                    snippet
                                );

                            }

                        }
                    }
                >

                  
                   Add Snippet to Basket
                 

                </button>

            </div>

        </WorkspaceDrawer>

    );

}



//========================================================
// Get Content Label
//========================================================

function getContentLabel(
    contentType)
{

    switch (
        contentType
    )
    {

        case "TABULAR":

            return "Tabular Data";


        case "IMAGE":

            return "Image Data";


        case "DRAWING":

            return "Drawing Data";


        case "MIXED":

            return "Complex Data";


        case "COMPLEX":

            return "Complex Data";


        default:

            return "Text Data";

    }

}



//========================================================
// Get Content Description
//========================================================

function getContentDescription(
    contentType)
{

    switch (
        contentType
    )
    {

        case "TABULAR":

            return (
                "This page contains structured tabular data. " +
                "Use the source page to preserve its original " +
                "layout and context."
            );


        case "IMAGE":

            return (
                "This page contains image-based content. " +
                "Use the source page to view the original " +
                "visual information and context."
            );


        case "DRAWING":

            return (
                "This page contains drawing or graphical content. " +
                "Use the source page to preserve its original " +
                "layout and detail."
            );


        case "MIXED":

        case "COMPLEX":

            return (
                "This page contains complex structured content. " +
                "Use the source page to preserve its original " +
                "layout and context."
            );


        default:

            return "";

    }

}



//========================================================
// Styles
//========================================================

const styles =
{

    header:
    {
        minHeight: "96px",

        padding: "22px 24px",

        display: "flex",

        justifyContent: "space-between",

        alignItems: "flex-start",

        borderBottom:
            "1px solid rgba(255,255,255,0.08)"
    },

    eyebrow:
    {
        marginBottom: "7px",

        fontSize: "10px",

        fontWeight: 700,

        letterSpacing: "1.4px",

        color:
            "rgba(255,255,255,0.42)"
    },

    documentTitle:
    {
        maxWidth: "420px",

        fontSize: "16px",

        fontWeight: 600,

        lineHeight: "1.4",

        color: "#ffffff"
    },

    page:
    {
        marginTop: "5px",

        fontSize: "12px",

        color:
            "rgba(255,255,255,0.52)"
    },

    closeButton:
    {
        width: "34px",

        height: "34px",

        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        flexShrink: 0,

        marginLeft: "15px",

        padding: 0,

        background:
            "rgba(255,255,255,0.06)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderRadius: "50%",

        color:
            "rgba(255,255,255,0.72)",

        fontSize: "21px",

        fontWeight: 300,

        lineHeight: 1,

        cursor: "pointer"
    },

    content:
    {
        flex: 1,

        minHeight: 0,

        padding: "24px",

        overflowY: "auto"
    },

    sectionLabel:
    {
        marginBottom: "10px",

        fontSize: "10px",

        fontWeight: 700,

        letterSpacing: "1.2px",

        color:
            "rgba(255,255,255,0.36)"
    },

    contentPanel:
    {
        padding: "20px",

        background:
            "rgba(255,255,255,0.055)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderRadius: "8px",

        boxShadow:
            "0 8px 24px rgba(0,0,0,0.12)"
    },

    contentType:
    {
        marginBottom: "8px",

        fontSize: "15px",

        fontWeight: 700,

        color: "#ffffff"
    },

    contentDescription:
    {
        fontSize: "13px",

        lineHeight: "1.65",

        color:
            "rgba(255,255,255,0.62)"
    },

    snippetPanel:
    {
        padding: "20px",

        background:
            "rgba(255,255,255,0.055)",

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderRadius: "8px",

        boxShadow:
            "0 8px 24px rgba(0,0,0,0.12)",

        fontSize: "14px",

        lineHeight: "1.75",

        whiteSpace: "pre-wrap",

        color:
            "rgba(255,255,255,0.82)"
    },

    expandButton:
    {
        marginTop: "14px",

        padding: 0,

        background: "transparent",

        border: "none",

        color:
            "rgba(255,255,255,0.62)",

        fontSize: "12px",

        fontWeight: 600,

        cursor: "pointer"
    },

    extractedPanel:
    {
        marginTop: "14px",

        padding: "18px",

        background:
            "rgba(0,0,0,0.16)",

        border:
            "1px solid rgba(255,255,255,0.07)",

        borderRadius: "8px"
    },

    extractedLabel:
    {
        marginBottom: "10px",

        fontSize: "9px",

        fontWeight: 700,

        letterSpacing: "1.2px",

        color:
            "rgba(255,255,255,0.34)"
    },

    extractedText:
    {
        fontSize: "12px",

        lineHeight: "1.7",

        whiteSpace: "pre-wrap",

        color:
            "rgba(255,255,255,0.62)"
    },

    pageAction:
    {
        display: "flex",

        justifyContent: "flex-end",

        marginTop: "16px"
    },

    viewPageButton:
    {
        minWidth: "140px",

        padding: "11px 16px",

        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        gap: "20px",

        background:
            "rgba(255,255,255,0.07)",

        border:
            "1px solid rgba(255,255,255,0.10)",

        borderRadius: "6px",

        color:
            "rgba(255,255,255,0.90)",

        fontSize: "13px",

        fontWeight: 600,

        cursor: "pointer"
    },

    buttonArrow:
    {
        fontSize: "16px",

        fontWeight: 300,

        opacity: 0.7
    },

    footer:
    {
        padding: "16px 20px",

        display: "flex",

        justifyContent: "space-between",

        alignItems: "center",

        gap: "10px",

        background:
            "rgba(0,0,0,0.14)",

        borderTop:
            "1px solid rgba(255,255,255,0.08)"
    },

    secondaryButton:
    {
        padding: "11px 15px",

        background:
            "rgba(255,255,255,0.06)",

        border:
            "1px solid rgba(255,255,255,0.10)",

        borderRadius: "6px",

        color:
            "rgba(255,255,255,0.82)",

        fontSize: "12px",

        fontWeight: 600,

        cursor: "pointer"
    },

    primaryButton:
    {
        padding: "12px 17px",

        background: OMNISCAN_BLUE,

        border: "none",

        borderRadius: "6px",

        boxShadow:
            "0 6px 18px rgba(0,0,0,0.18)",

        color: "#ffffff",

        fontSize: "12px",

        fontWeight: 600,

        cursor: "pointer"
    }

};